import { UnderlinedHeader } from '../../common-elements';
import styled from 'styled-components';

export const PermissionsHeaderColumn = styled.div`
  flex: 1 1 auto;
  li {
    color: black;
    list-style-type: none;
  }
  li::before {
    content: "– ";
  }
`;

export const PermissionsHeader = styled(UnderlinedHeader)`
    border-bottom: 1px solid rgba(38, 50, 56, 0.3);
    margin: 1em 0 1em 0;
    color: rgba(38, 50, 56, 0.5);
    font-weight: normal;
    text-transform: uppercase;
    font-size: 0.929em;
    line-height: 20px;
`;

export const PermissionCells = styled.td`
    padding: 10px 0;
    font-family: MuseoSansW05;
    width: ${(props) => props.theme.schema.defaultDetailsWidth};
    box-sizing: border-box;

    tr.expanded & {
        border-bottom: none;
    }
`;

